import { Injectable } from '@angular/core';
import { DataCoreService} from '@dabnet-kamu/libs/ui';
import { TmsAmbarBolumService } from '../ctl-tms-ambar-bolum.service';
@Injectable()
export class Service {

    constructor(private dataCoreService: DataCoreService, private tmsAmbarBolumService: TmsAmbarBolumService) {}

    getData(control: any) {
            const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity);
            dataSource.select([
            ]);
            const filterArr = [];
            if (this.tmsAmbarBolumService.blokCode) filterArr.push(['BlokKod', '=', this.tmsAmbarBolumService.blokCode]);
            if (filterArr.length > 0) dataSource.filter(filterArr);
            return dataSource;
    }

}
